import { CabinetPage } from "./types";

// Walks the cabinet page tree producing menu items. The first root page maps
// to "/", others to "/<segment>"; nested pages compose a "/<parent>/<child>"
// path. `leaf` builds a terminal item; `branch` builds a parent item and
// receives its already-built children (with the parent itself prepended as a
// self-nav item by the caller if desired).
export type CabinetMenuLeaf<T> = (page: CabinetPage, path: string) => T;
export type CabinetMenuBranch<T> = (page: CabinetPage, path: string, children: T[]) => T;

export function buildCabinetMenuItems<T>(
  rootPages: CabinetPage[],
  childrenOf: (id: string) => CabinetPage[],
  leaf: CabinetMenuLeaf<T>,
  branch: CabinetMenuBranch<T>,
): T[] {
  const walk = (pages: CabinetPage[], isRoot: boolean, parentPath: string): T[] =>
    pages.map((page, index) => {
      const path = isRoot && index === 0 ? "/" : `${parentPath}/${page.segment}`;
      const sub = childrenOf(page.id);
      if (sub.length > 0) return branch(page, path, walk(sub, false, path));
      return leaf(page, path);
    });

  return walk(rootPages, true, "");
}
